// Auto-generated by splitter.py — do not regenerate; edit directly.

import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { toast } from '../../lib/buses';
import { Modal } from '../../ui/Modal';

export const PolicyEditorModal = ({ open, onClose, title, subtitle, rules = [], onSave }) => {
  const [edits, setEdits] = useState({});
  // Adjust state during render (not in an effect) when `open` changes — see
  // react.dev "Adjusting some state when a prop changes".
  const [prevOpen, setPrevOpen] = useState(open);
  if (open !== prevOpen) {
    setPrevOpen(open);
    if (!open) setEdits({});
  }
  if (!open) return null;
  const setField = (key, value) => setEdits(prev => ({ ...prev, [key]: value }));
  const dirtyCount = Object.keys(edits).length;
  const handleSave = () => {
    if (onSave) {
      const updated = rules.map(r => ({ ...r, value: edits[r.key] !== undefined ? edits[r.key] : r.value }));
      onSave(updated);
    }
    toast(`${title} saved`, 'success', `${dirtyCount} change${dirtyCount !== 1 ? 's' : ''} applied · audit logged`);
    onClose();
  };
  return (
    <Modal open={open} onClose={onClose} width="max-w-[560px]" title={title} sub={subtitle}>
      <div className="space-y-3">
        {rules.map((r, i) => {
          const key = r.key || `rule_${i}`;
          const current = edits[key] !== undefined ? edits[key] : r.value;
          return (
            <div key={key} className="border border-[#E6E4E1] rounded-md p-3 bg-white">
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="min-w-0 flex-1">
                  <div className="text-[12.5px] font-medium text-[#1F2937]">{r.label}</div>
                  {r.help && <div className="text-[10.5px] text-[#6B7280] mt-0.5">{r.help}</div>}
                </div>
                {r.type === 'toggle' && (
                  <button onClick={() => setField(key, !current)} className={`relative w-9 h-5 rounded-full transition-colors ${current ? 'bg-[#1F2937]' : 'bg-[#E6E4E1]'}`}>
                    <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-transform ${current ? 'translate-x-4' : ''}`} />
                  </button>
                )}
              </div>
              {r.type === 'number' && (
                <div className="flex items-center gap-2">
                  <input type="number" value={current} onChange={e => setField(key, e.target.value)} className="w-32 h-8 bg-white border border-[#E6E4E1] rounded-md px-2.5 text-[12.5px] tabular-nums focus:outline-none focus:border-[#D8D5CF]" />
                  {r.unit && <span className="text-[11.5px] text-[#6B7280]">{r.unit}</span>}
                </div>
              )}
              {r.type === 'select' && (
                <select value={current} onChange={e => setField(key, e.target.value)} className="h-8 bg-white border border-[#E6E4E1] rounded-md px-2.5 text-[12.5px] focus:outline-none focus:border-[#D8D5CF]">
                  {r.options.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              )}
              {r.type === 'text' && (
                <input type="text" value={current} onChange={e => setField(key, e.target.value)} className="w-full h-8 bg-white border border-[#E6E4E1] rounded-md px-2.5 text-[12.5px] focus:outline-none focus:border-[#D8D5CF]" />
              )}
            </div>
          );
        })}
        <div className="bg-[#FEF3C7] border border-[#FDE68A] rounded-md p-2.5 text-[11px] text-[#8A5A12] flex items-start gap-2">
          <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
          <span>Changes take effect immediately on new orders. In-flight reservations are not affected. All edits are logged to the audit trail.</span>
        </div>
      </div>
      <div className="px-5 py-3 border-t border-[#EEEDEA] bg-[#FBFAF7] -mx-5 -mb-4 mt-4 flex items-center justify-between">
        <span className="text-[11.5px] text-[#6B7280]">{dirtyCount > 0 ? `${dirtyCount} change${dirtyCount !== 1 ? 's' : ''} pending` : 'No changes'}</span>
        <div className="flex items-center gap-2">
          <button onClick={onClose} className="h-8 px-3 text-[12px] font-medium rounded-md text-[#1F2937] hover:bg-[#F2F1ED]">Cancel</button>
          <button onClick={handleSave} disabled={dirtyCount === 0} className="h-8 px-3 text-[12px] font-medium rounded-md bg-[#1F2937] hover:bg-[#111827] disabled:bg-[#9CA3AF] text-white">Save changes</button>
        </div>
      </div>
    </Modal>
  );
};

